const initialState = {
    spgMappingListLoading: false,
    error: null,
    message:null,
    spgMappingList:null,
    postSpgMapping:null,
    postSpgMappingError:null,
    deleteSpgMapping:null,
    deleteSpgMappingError:null,
    getSpgList:null,
}

const articleWebinarMppingReducer = (state = initialState, action) => {
    switch(action.type){
        case 'GET_CMS_SPG_MAPPING_REQUEST':
            return {
                ...state,
                spgMappingListLoading:true,
            }    
        case 'GET_CMS_SPG_MAPPING_SUCCESS':
            return {
                ...state,
                spgMappingListLoading:false,
                spgMappingList:action.payload,
            }
        case 'GET_CMS_SPG_MAPPING_FAILURE':
            return {
                ...state,
                spgMappingListLoading:false,
                error:action.payload,
            }
        case 'POST_CMS_SPG_MAPPING_SUCCESS':
            return {
                ...state,
                postSpgMapping:action.payload,
            }
        case 'POST_CMS_SPG_MAPPING_FAILURE':
            return {
                ...state,
                postSpgMappingError:action.payload,
            }            
        case "DELETE_CMS_SPG_MAPPING_SUCCESS":
            return{
                ...state, 
                deleteSpgMapping:action.payload
            }
        case "DELETE_CMS_SPG_MAPPING_FAILURE":
            return{
                ...state, 
                deleteSpgMappingError:action.payload
            }
        case "CLEAR_CMS_SPG_MAPPING":
            return{
                deleteSpgMapping:null,
            }
        case 'GET_CMS_SPG_LIST':
            return {
                ...state,
                getSpgList:action.payload,
                spgMappingListLoading:false
            }    
        default: return state
    }
}

export default articleWebinarMppingReducer